"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicFilterDtoCategoryEnum = exports.PublicFilterDtoTypeEnum = void 0;
var PublicFilterDtoTypeEnum;
(function (PublicFilterDtoTypeEnum) {
    PublicFilterDtoTypeEnum["businessCustomerNews"] = "businessCustomerNews";
    PublicFilterDtoTypeEnum["businessCustomerFaq"] = "businessCustomerFaq";
    PublicFilterDtoTypeEnum["businessCustomerAgreements"] = "businessCustomerAgreements";
    PublicFilterDtoTypeEnum["amiFaq"] = "amiFaq";
})(PublicFilterDtoTypeEnum = exports.PublicFilterDtoTypeEnum || (exports.PublicFilterDtoTypeEnum = {}));
var PublicFilterDtoCategoryEnum;
(function (PublicFilterDtoCategoryEnum) {
    PublicFilterDtoCategoryEnum["orders"] = "orders";
    PublicFilterDtoCategoryEnum["ratings"] = "ratings";
    PublicFilterDtoCategoryEnum["salesPromotion"] = "salesPromotion";
    PublicFilterDtoCategoryEnum["user"] = "user";
    PublicFilterDtoCategoryEnum["company"] = "company";
    PublicFilterDtoCategoryEnum["deliveryArea"] = "deliveryArea";
    PublicFilterDtoCategoryEnum["prices"] = "prices";
    PublicFilterDtoCategoryEnum["margin"] = "margin";
    PublicFilterDtoCategoryEnum["options"] = "options";
    PublicFilterDtoCategoryEnum["privacy"] = "privacy";
    PublicFilterDtoCategoryEnum["agb"] = "agb";
    PublicFilterDtoCategoryEnum["adv"] = "adv";
    PublicFilterDtoCategoryEnum["agency"] = "agency";
    PublicFilterDtoCategoryEnum["deliveryTimes"] = "deliveryTimes";
    PublicFilterDtoCategoryEnum["analysis"] = "analysis";
    PublicFilterDtoCategoryEnum["notification"] = "notification";
    PublicFilterDtoCategoryEnum["userSettings"] = "userSettings";
    PublicFilterDtoCategoryEnum["agencySettings"] = "agencySettings";
    PublicFilterDtoCategoryEnum["profile"] = "profile";
    PublicFilterDtoCategoryEnum["accessControl"] = "accessControl";
    PublicFilterDtoCategoryEnum["amiTools"] = "amiTools";
    PublicFilterDtoCategoryEnum["amiPricesCharts"] = "amiPricesCharts";
    PublicFilterDtoCategoryEnum["amiBCSupport"] = "amiBCSupport";
    PublicFilterDtoCategoryEnum["amiCCSupport"] = "amiCCSupport";
    PublicFilterDtoCategoryEnum["amiMarketing"] = "amiMarketing";
    PublicFilterDtoCategoryEnum["amiStatistic"] = "amiStatistic";
    PublicFilterDtoCategoryEnum["quickAdministration"] = "quickAdministration";
    PublicFilterDtoCategoryEnum["dashboard"] = "dashboard";
})(PublicFilterDtoCategoryEnum = exports.PublicFilterDtoCategoryEnum || (exports.PublicFilterDtoCategoryEnum = {}));
//# sourceMappingURL=public-filter-dto.js.map